export const skillCards = [
  {
    id: 1,
    title: "Programming Languages",
    tags: ["Python", "JavaScript", "Java", "SQL"],
    icon: "code",
  },
  {
    id: 2,
    title: "Frameworks",
    tags: ["React", "Node.js", "Express", "FastAPI"],
    icon: "layers",
  },
  {
    id: 3,
    title: "Tools & Architecture",
    tags: ["Git", "Unit Testing", "REST APIs", "Clean Code"],
    icon: "tool",
  },
];
